<div class="lateral-menu-wrapper" [ngClass]="classes">
  <img src="{{closeImageUrl}}" alt="" *ngIf="!loading" (click)="closeLateralMenuWrapper()" class="close-button">
  <div class="lateral-menu--content">
      <ng-content></ng-content>
  </div>
</div>
